import {
  FilterMode,
  PublisherRepresentative_OrderBy,
  PublisherRepresentative,
  SortOrder,
  PublisherRepresentative_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";

export const publisherRepresentativeService = {
  createOne: () => (): Promise<string> => new Promise(() => ""),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.publisherRepresentativeOne({ id });
    return result.publisherRepresentativeOne as PublisherRepresentative;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    _language: string = "es",
    orderBy: PublisherRepresentative_OrderBy[] | null = null,
    filter: PublisherRepresentative_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: PublisherRepresentative_Filter | undefined;
    if (searchValue !== "") {
      where = { name: { contains: searchValue, mode: FilterMode.Insensitive } };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.publisherRepresentativeListWithOffset({
      offset,
      take,
      orderBy: orderBy ? orderBy : [{ name: SortOrder.Asc }],
      where,
    });
    const list = nullToUndefinedRecursive(
      result.publisherRepresentativeListWithOffset
    ) as PublisherRepresentative[];
    return { list, orderBy };
  },
};
